'use strict'

import Axios  from 'axios'
import Config from '../../configuration.js'

/**
 * http://localhost/Specif/EUDO_07676/root/SectionORM/filedata/liste?descid=10608
 */

var capitalizeFirstLetter = function(string) {
  string = string.toLowerCase()
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var charger = function(payload){



  return new Promise(function(Resolve){
    Axios.get(Config.url.service + '/filedata/liste?bien='+payload.bien+'&emploi='+payload.emploi+'&descid=' + payload.DescId)
    .then(function(Reponse){
      Reponse.data.items.sort((a, b) => a.libelle.trim().localeCompare(b.libelle.trim()))  // Tri des valeurs par le libellé
      Resolve(Reponse.data.items)
    })
  })
}

export default {
  namespaced: true,

  /**
   * STATE
   */
  state: {
    catalogues: [], // tableau d'objet
  },

  /**
   * MUTATIONS
   */
  mutations: {
    /**
     * Actualise la liste des offres immos
     */
    catalogues(State,  { DescId, Items}){
      console.log("DescId : " + DescId)
      for(var i=0; i<Items.length;i++){
        Items[i].libelle = capitalizeFirstLetter(Items[i].libelle)
      }
      
      State.catalogues[DescId] = Items
    },

  },

  /*
   * GETTERS
   */
  getters: {
    /**
     * Actualise la liste des offres immos
     */
    catalogues(State){
      return function(DescId){
        return State.catalogues[DescId]
      }
    },
  },

  /**
   * ACTIONS
   */
  actions: {
    async liste(Context, payload){
      if (Context.getters['catalogues'](payload.DescId) != undefined) return // Catalogue déja chargé

      var items = await charger(payload) // Requete Ajax
      var descid = payload.DescId
      
      Context.commit('catalogues', { DescId : descid, Items: items })
    },
  }, // ACTIONS
}
